module.exports = __webpack_public_path__ + "img/kankou_23.265bc9de.jpg";